import React from "react";
import TabsPagination from "../results/tab-panel/TabsPagination";
import { toCustomDate } from "../../utils/date";
import { calculateTotalPrice } from "../../utils/calculations";
import { tabNames } from "../../utils/strings";

const unitTypes = [{ name: "" }, { name: "BOX" }, { name: "CBM" }, 
{ name: "KGS" },{ name: "LTR" },
{ name: "MTR" },{ name: "PACK" },
{ name: "PAIR" },{ name: "PART" },
{ name: "PCS" },{ name: "SET" }, { name: "UNIT" }
];
export const logos = [{ name: "medmar" }, { name: "rina" }];

export const tabs = [
  {
    id: 0,
    text: "Enquiries",
    tabName: "enquiries",
    content: (
      <TabsPagination
        tabName="enquiries"
        cells={[
          {
            dataField: "date",
            caption: "Date",
            type: "date",
            defaultValue: toCustomDate(),
          },
          {
            dataField: "equipment",
            caption: "Equipment",
            type: "vesselSelect",
          },
          { dataField: "maker", caption: "Maker", type: "vesselSelect" },
          { dataField: "type", caption: "Type", type: "vesselSelect" },
          { dataField: "serial", caption: "Serial", type: "text" },
          {
            dataField: "subject",
            caption: "Subject",
            defaultValue: "SPARE PARTS",
            type: "text",
          },
          {
            dataField: "comments",
            caption: "Comments",
            type: "textarea",
          },
        ]}
      />
    ),
  },
  {
    id: 1,
    text: "Offers",
    tabName: "quotations",
    content: (
      <TabsPagination
        itemInfoFields={{
          price: true,
          packing: true,
          discount: true,
          finalAmount: true,
          includeCommission: true,
        }}
        tabName="quotations"
        cells={[
          {
            dataField: "date",
            caption: "Date",
            type: "date",
            defaultValue: toCustomDate(),
          },
          { dataField: "state", caption: "State", type: "text" },
          {
            dataField: "subject",
            caption: "Subject",
            type: "text",
            defaultValue: "SPARE PARTS",
          },
          {
            dataField: "currency",
            caption: "Currency",
            type: "select",
            resourceName: "currencies",
            resourcePath: "currency",
          },
          {
            dataField: "equipment",
            caption: "Equipment",
            type: "vesselSelect",
            disabled: true,
          },
          {
            dataField: "maker",
            caption: "Maker",
            type: "vesselSelect",
            disabled: true,
          },
          {
            dataField: "type",
            caption: "Type",
            type: "vesselSelect",
            disabled: true,
          },
          {
            dataField: "serial",
            caption: "Serial",
            type: "text",
            disabled: true,
          },
          {
            dataField: "remarks",
            caption: "Remarks",
            type: "textarea",
          },
          {
            dataField: "terms",
            caption: "Terms",
            type: "textarea",
          },
        ]}
      />
    ),
  },
  {
    id: 2,
    text: "P Orders",
    tabName: "purchase_orders",
    content: (
      <TabsPagination
        itemInfoFields={{
          price: true,
          discount: true,
          finalAmount: true,
          includeCommission: false,
        }}
        tabName="purchase_orders"
        cells={[
          {
            dataField: "date",
            caption: "Date",
            type: "date",
            defaultValue: toCustomDate(),
          },
          { dataField: "state", caption: "State", type: "text" },
          {
            dataField: "equipment",
            caption: "Equipment",
            type: "vesselSelect",
          },
          {
            dataField: "subject",
            caption: "Subject",
            type: "text",
            defaultValue: "SPARE PARTS",
          },
          { dataField: "maker", caption: "Maker", type: "vesselSelect" },
          {
            dataField: "type",
            caption: "Type",
            type: "vesselSelect",
          },
          { dataField: "serial", caption: "Serial", type: "text" },
          { dataField: "message_id", caption: "Message Id", type: "text" },
          {
            dataField: "vendor",
            caption: "Vendor",
            type: "select",
            resourceName: "vendors",
            resourcePath: "vendor",
          },
          {
            dataField: "currency",
            caption: "Currency",
            type: "select",
            resourceName: "currencies",
            resourcePath: "currency",
          },
          {
            dataField: "remarks",
            caption: "Remarks",
            type: "textarea",
          },
          {
            dataField: "terms",
            caption: "Terms",
            type: "textarea",
          },
        ]}
      />
    ),
  },
  {
    id: 3,
    text: "Order Acks",
    tabName: "order_acknowledgments",
    content: (
      <TabsPagination
        itemInfoFields={{
          price: true,
          packing: true,
          trans: true,
          discount: true,
          finalAmount: true,
          includeCommission: true,
        }}
        tabName="order_acknowledgments"
        cells={[
          {
            dataField: "date",
            caption: "Date",
            type: "date",
            defaultValue: toCustomDate(),
          },
          {
            dataField: "equipment",
            caption: "Equipment",
            type: "vesselSelect",
          },
          { dataField: "maker", caption: "Maker", type: "vesselSelect" },
          { dataField: "type", caption: "Type", type: "vesselSelect" },

          { dataField: "serial", caption: "Serial", type: "text" },
          {
            dataField: "subject",
            caption: "Subject",
            type: "text",
            defaultValue: "SPARE PARTS",
          },
          {
            dataField: "currency",
            caption: "Currency",
            type: "select",
            resourceName: "currencies",
            resourcePath: "currency",
          },
          {
            dataField: "remarks",
            caption: "Remarks",
            type: "textarea",
          },
          {
            dataField: "terms",
            caption: "Terms",
            type: "textarea",
          },
        ]}
      />
    ),
  },
  {
    id: 4,
    text: "Pack Lists",
    tabName: "packing_lists",
    content: (
      <TabsPagination
        tabName="packing_lists"
        cells={[
          {
            dataField: "date",
            caption: "Date",
            type: "date",
            defaultValue: toCustomDate(),
          },
          {
            dataField: "consignee_address",
            caption: "Consignee Address",
            type: "textarea",
          },
          {
            dataField: "remarks",
            caption: "Remarks",
            type: "textarea",
          },
          {
            dataField: "terms",
            caption: "Terms",
            type: "textarea",
          },
          {
            dataField: "equipment",
            caption: "Equipment",
            type: "vesselSelect",
          },
          { dataField: "maker", caption: "Maker", type: "vesselSelect" },
          { dataField: "serial", caption: "Serial", type: "text" },
          { dataField: "type", caption: "Type", type: "vesselSelect" },
          {
            dataField: "message_id",
            caption: "Message Id",
            type: "vesselSelect",
          },
          {
            dataField: "currency",
            caption: "Currency",
            type: "select",
            resourceName: "currencies",
            resourcePath: "currency",
          },
        ]}
      />
    ),
  },
  {
    id: 5,
    text: "Proforma Inv",
    tabName: "proforma_invoices",
    content: (
      <TabsPagination
        tabName="proforma_invoices"
        cells={[
          {
            dataField: "date",
            caption: "Date",
            type: "date",
            defaultValue: toCustomDate(),
          },
          {
            dataField: "equipment",
            caption: "Equipment",
            type: "vesselSelect",
          },
          { dataField: "address", caption: "Address", type: "textarea" },
          {
            dataField: "remarks",
            caption: "Remarks",
            type: "textarea",
          },
          {
            dataField: "terms",
            caption: "Terms",
            type: "textarea",
          },
          { dataField: "message_id", caption: "Message Id", type: "number" },
          {
            dataField: "currency",
            caption: "Currency",
            type: "select",
            resourcePath: "currency",
            resourceName: "currencies",
          },
        ]}
      />
    ),
  },
  {
    id: 6,
    text: "Invoices",
    tabName: "invoices",
    content: (
      <TabsPagination
        itemInfoFields={{
          price: true,
          discount: true,
          finalAmount: true,
          packing: true,
          trans: true,
          includeCommission: true,
        }}
        tabName="invoices"
        cells={[
          {
            dataField: "date",
            caption: "Date",
            type: "date",
            defaultValue: toCustomDate(),
          },
          {
            dataField: "equipment",
            caption: "Equipment",
            type: "vesselSelect",
          },
          {
            dataField: "address",
            caption: "Address",
            type: "textarea",
          },
          {
            dataField: "remarks",
            caption: "Remarks",
            type: "textarea",
          },
          {
            dataField: "terms",
            caption: "Terms",
            type: "textarea",
          },
          { dataField: "message_id", caption: "Message Id", type: "text" },
          { dataField: "amount_paid", caption: "Amount Paid", type: "number" },
          {
            dataField: "currency",
            caption: "Currency",
            type: "select",
            resourcePath: "currency",
            resourceName: "currencies",
          },
        ]}
      />
    ),
  },
];

export const itemGridColumns = {
  [tabNames[0]]: [
    { dataField: "line_number", caption: "#", width: 80 },
    {
      dataField: "part_number",
      caption: "Part No",
      width: 100,
      type: "number",
    },
    { dataField: "description", caption: "Description", width: 200 },
    {
      dataField: "unit_type",
      caption: "Unit Type",
      type: "select",
      dataSource: unitTypes,
      width: 70,
    },
    {
      dataField: "quantity",
      caption: "Qty",
      width: 50,
      type: "number",
    },
  ],
  [tabNames[1]]: [
    { dataField: "line_number", caption: "#", width: 40 },
    { dataField: "part_number", caption: "Part No", width: 60, type: "number" },
    { dataField: "description", caption: "Description", width: 200 },
    {
      dataField: "unit_type",
      caption: "Unit Type",
      type: "select",
      dataSource: unitTypes,
      width: 70,
    },
    {
      dataField: "quantity",
      caption: "Qty",
      width: 50,
      type: "number",
    },
    {
      dataField: "price",
      caption: "Price",
      width: 50,
      type: "number",
    },
    {
      dataField: "commission",
      caption: "Commission",
      width: 70,
      type: "number",
    },
    {
      dataField: "delivery_time",
      caption: "Delivery time",
      width: 50,
    },
    {
      dataField: "vendor",
      caption: "Vendors",
      type: "select",
      resourceName: "vendors",
      resourcePath: "vendor",
      width: 150,
    },
    {
      dataField: "totalValue",
      caption: "Total",
      width: 100,
      allowEditing: false,
      calculateCellValue: calculateTotalPrice,
      allowSorting: false,
    },
  ],
  [tabNames[2]]: [
    { dataField: "line_number", caption: "#", width: 50 },
    { dataField: "part_number", caption: "Part No", width: 60, type: "number" },
    { dataField: "description", caption: "Description", width: 200 },
    {
      dataField: "unit_type",
      caption: "Unit Type",
      type: "select",
      dataSource: unitTypes,
      width: 70,
    },
    {
      dataField: "quantity",
      caption: "Qty",
      width: 50,
      type: "number",
    },
    {
      dataField: "price",
      caption: "Price",
      width: 50,
      type: "number",
    },
    {
      dataField: "totalValue",
      caption: "Total",
      width: 100,
      allowEditing: false,
      calculateCellValue: calculateTotalPrice,
      allowSorting: false,
    },
    {
      dataField: "delivery_time",
      caption: "Delivery time",
      width: 50,
    },
    {
      dataField: "vendor",
      caption: "Vendors",
      type: "select",
      resourceName: "vendors",
      resourcePath: "vendor",
      width: 110,
    },
  ],
  [tabNames[3]]: [
    { dataField: "line_number", caption: "#", width: 50 },
    { dataField: "part_number", caption: "Part No", width: 60, type: "number" },
    { dataField: "description", caption: "Description", width: 200 },
    {
      dataField: "unit_type",
      caption: "Unit Type",
      type: "select",
      dataSource: unitTypes,
      width: 70,
    },
    {
      dataField: "quantity",
      caption: "Qty",
      width: 50,
      type: "number",
    },
    {
      dataField: "price",
      caption: "Price",
      width: 50,
      type: "number",
    },
    {
      dataField: "commission",
      caption: "Commission",
      width: 100,
      type: "number",
    },
    {
      dataField: "totalValue",
      caption: "Total",
      width: 50,
      allowEditing: false,
      calculateCellValue: calculateTotalPrice,
      allowSorting: false,
    },
    {
      dataField: "delivery_time",
      caption: "Delivery time",
      width: 100,
    },
  ],
  [tabNames[5]]: [
    { dataField: "line_number", caption: "#", width: 60 },
    { dataField: "part_number", caption: "Part No", width: 60, type: "number" },
    { dataField: "description", caption: "Description", width: 200 },
    {
      dataField: "unit_type",
      caption: "Unit Type",
      type: "select",
      dataSource: unitTypes,
      width: 70,
    },
    {
      dataField: "quantity",
      caption: "Qty",
      width: 50,
      type: "number",
    },
    {
      dataField: "price",
      caption: "Price",
      width: 50,
      type: "number",
    },
    {
      dataField: "totalValue",
      caption: "Total",
      width: 50,
      allowEditing: false,
      calculateCellValue: calculateTotalPrice,
      allowSorting: false,
    },
  ],
  [tabNames[6]]: [
    { dataField: "line_number", caption: "#", width: 50 },
    { dataField: "part_number", caption: "Part No", width: 60, type: "number" },
    { dataField: "description", caption: "Description", width: 200 },
    {
      dataField: "unit_type",
      caption: "Unit Type",
      type: "select",
      dataSource: unitTypes,
      width: 70,
    },
    {
      dataField: "quantity",
      caption: "Qty",
      width: 50,
      type: "number",
    },
    {
      dataField: "price",
      caption: "Price",
      width: 50,
      type: "number",
    },
    {
      dataField: "commission",
      caption: "Commission",
      width: 70,
      type: "number",
    },
    {
      dataField: "totalValue",
      caption: "Total",
      width: 50,
      allowEditing: false,
      calculateCellValue: calculateTotalPrice,
      allowSorting: false,
    },
  ],
};

export const contextMenuConfig = {
  enquiry: [
    {
      text: "Create offer",
      path: "quotation",
      resource: "enquiries",
      mode: "single",
    },
    { text: "Create report", path: "enquiry", mode: "report" },
    {
      text: "Create report with address & bank",
      mode: "reportWithAddresses",
    },
  ],
  quotation: [
    {
      text: "Create purchase order",
      path: "purchase-order",
      resource: "quotations",
      mode: "single",
    },
    { text: "Create report", path: "quotation", mode: "report" },
    {
      text: "Create report with address & bank",
      mode: "reportWithAddresses",
    },
  ],
  "purchase-order": [
    {
      text: "Create order acknowledgment",
      path: "order-acknowledgment",
      resource: "purchase-orders",
      mode: "multiple",
    },
    { text: "Create report", path: "purchase-order", mode: "report" },
    {
      text: "Create report with address & bank",
      mode: "reportWithAddresses",
    },
  ],
  "order-acknowledgment": [
    {
      text: "Create single packing list & single proforma",
      path: "packing-list",
      resource: "order-acknowledgments",
      mode: "single",
    },
    {
      text: "Create multiple packing list & single proforma",
      path: "packing-list",
      resource: "order-acknowledgments",
      mode: "multiple",
      per_vendor: true,
    },
    { text: "Create report", path: "order-acknowledgment", mode: "report" },
    {
      text: "Create report with address & bank",
      mode: "reportWithAddresses",
    },
    {
      text: "Sdoc report",

      items: [
        { text: "greek", mode: "specificReport", path: "sdoc_report" },
        { text: "hk", mode: "specificReport", path: "sdoc_report" },
      ],
    },
    {
      text: "M_d report",

      items: [
        { text: "greek", mode: "specificReport", path: "m_d_report" },
        { text: "hk", mode: "specificReport", path: "m_d_report" },
      ],
    },
  ],
  "packing-list": [
    {
      text: "Create invoice for this packing list",
      path: "invoice",
      resource: "packing-lists",
      mode: "single",
    },
    {
      text: "Create single invoice for all packing lists",
      path: "invoice",
      resource: "packing-lists",
      mode: "multiple",
    },
    { text: "Create report", path: "packing-list", mode: "report" },
    {
      text: "Create report with address & bank",
      mode: "reportWithAddresses",
    },
  ],
  "proforma-invoice": [
    { text: "Create report", path: "proforma-invoice", mode: "report" },
    {
      text: "Create report with address & bank",
      mode: "reportWithAddresses",
    },
  ],
  invoice: [
    { text: "Create report", path: "invoice", mode: "report" },
    { text: "Manage payments", mode: "payments" },
    {
      text: "Create report with address & bank",
      mode: "reportWithAddresses",
    },
  ],
};

export const API_URL = `${window.location.origin || "https://localhost"}/api`;
